import React from 'react';
import { StarIcon } from 'lucide-react';
import { testimonials } from '../data/testimonials';
export const ExtendedTestimonialsSection = ({
  isInitial = false
}: {
  isInitial?: boolean;
}) => {
  const data = isInitial ? testimonials.slice(0, 2) : testimonials;
  const dark = isInitial;
  return <section className={`py-12 md:py-16 px-4 md:px-6 overflow-hidden ${dark ? 'bg-familia-dark' : 'bg-familia-light'}`} data-id="element-49" data-mp="2p1f5xjxt0ihw">
      <div className={`mx-auto w-full ${isInitial ? 'max-w-5xl' : 'max-w-7xl'}`} data-id="element-50" data-mp="2k2vkdkn4h8q2">
        {!isInitial && <h2 className="text-[26px] sm:text-3xl md:text-4xl font-display font-bold text-center text-familia-ink mb-8 md:mb-12 leading-tight max-w-3xl mx-auto" data-id="element-51" data-mp="2fz5yj2xu158q">
            Lo que dicen las familias y cuidadores que ya lo usan
          </h2>}
        {/* Mobile: carrusel con scroll-snap que deja ver la tarjeta siguiente */}
        <div className={`no-scrollbar flex overflow-x-auto snap-x snap-mandatory gap-3 -mx-4 px-4 scroll-px-4 md:mx-0 md:px-0 md:overflow-visible md:grid md:grid-cols-2 md:gap-6 ${isInitial ? '' : 'lg:grid-cols-3'}`} data-id="element-52" data-mp="98zp3ayk2gon">
          {data.map(t => <figure key={t.name} className={`snap-start shrink-0 w-[85%] md:w-auto border p-6 md:p-8 rounded-2xl flex flex-col ${dark ? 'bg-familia-darkCard border-familia-darkBorder' : 'bg-familia-lightCard border-familia-lightBorder'}`} data-id="element-53" data-mp="3bfjtjzzggca1">
              <div className="flex items-center gap-4 mb-5" data-id="element-54" data-mp="32fn25qlokzba">
                <div aria-hidden="true" className="w-12 h-12 rounded-full bg-familia-accent text-white flex items-center justify-center font-bold text-base leading-none shrink-0 overflow-hidden whitespace-nowrap" data-id="element-55" data-mp="3q4og1tda92ny">
                  {getInitials(t.name)}
                </div>
                <div className="min-w-0" data-id="element-56" data-mp="3gcsgsezgn6i5">
                  <div className="flex gap-0.5 mb-1" aria-label="5 de 5 estrellas" data-id="element-57" data-mp="3lcxz34jubgnk">
                    {[0, 1, 2, 3, 4].map(n => <StarIcon key={n} className="w-4 h-4 text-familia-gold fill-familia-gold" aria-hidden="true" data-id="element-58" data-mp="cwv2btu9nce0" />)}
                  </div>
                  <div className={`font-bold text-[17px] ${dark ? 'text-white' : 'text-familia-ink'}`} data-id="element-59" data-mp="hqplmw5ylpck">
                    {t.name}
                  </div>
                  <div className={`text-[14px] ${dark ? 'text-familia-onDarkMuted' : 'text-familia-inkMuted'}`} data-id="element-60" data-mp="mmjxpqb8awvx">
                    {t.city}
                  </div>
                </div>
              </div>
              <blockquote className={`text-body italic flex-grow mb-5 ${dark ? 'text-white/90' : 'text-familia-ink'}`} data-id="element-61" data-mp="dk27l0sgdk3n">
                “{t.quote}”
              </blockquote>
              <figcaption className={`text-[14px] font-semibold pt-4 border-t mt-auto ${dark ? 'text-familia-accent border-familia-darkBorder' : 'text-familia-inkMuted border-familia-lightBorder'}`} data-id="element-62" data-mp="3uiru401e6d0">
                {t.role} · {t.city}
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
};
function getInitials(name: string): string {
  return name.replace(/\./g, '').split(' ').filter(Boolean).map(part => part[0]).slice(0, 2).join('').toUpperCase();
}